export default __webpack_public_path__ + "static/IMG_9245-345ca341a8fd209b12e7495bc74defec.jpg";